import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("yaara_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("yaara_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const wsUrl = (streamId) => {
  const base = BACKEND_URL
    ? BACKEND_URL.replace(/^http/, "ws")
    : (typeof window !== "undefined" ? `${window.location.protocol === "https:" ? "wss:" : "ws:"}//${window.location.host}` : "ws://localhost:8001");
  return `${base}/api/ws/stream/${streamId}?token=${localStorage.getItem("yaara_token")}`;
};

export const TIER_COLORS = {
  Friendship: "#C9A0DC",
  Star: "#F48FB1",
  Silver: "#B0BEC5",
  Gold: "#F6C445",
  Pearl: "#F5E6C8",
  Ruby: "#FF2D78",
  Emerald: "#22B573",
  Sapphire: "#1E6FE0",
  Diamond: "#9AD7F5",
  "Black Diamond": "#8A8A99",
  Kohinoor: "#F6D365",
  Maharaja: "#16C79A",
  Shahenshah: "#F5A623",
};

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Something went wrong";
};

export let TIERS = [];
export async function loadTiers() {
  try {
    const { data } = await api.get("/tiers");
    TIERS = data.tiers;
    data.tiers.forEach((t) => {
      if (t.color) TIER_COLORS[t.name] = t.color;
    });
  } catch { }
}
export const tierPerks = (name) => TIERS.find((t) => t.name === name)?.perks || {};
export const tierIcon = (name) => TIERS.find((t) => t.name === name)?.icon_url || null;
export const tierImage = (name) => TIERS.find((t) => t.name === name)?.image || null;

export default api;
